import React from "react";

function BackIcon() {
  return (
    <svg className="svg-icon" width={20} height={20} viewBox="0 0 20 20">
      <path
        fill="#178e1c"
        strokeWidth="20"
        d="M18.271 9.212H3.615l4.184-4.184a.782.782 0 10-1.107-1.107L1.21 9.403c-.016.014-.036.018-.052.034a.766.766 0 00-.209.66.76.76 0 00.164.38c.021.026.021.061.045.085.015.016.034.02.05.033l5.484 5.483a.78.78 0 001.107 0 .78.78 0 000-1.105l-4.184-4.185h14.656a.788.788 0 100-1.576z"
      ></path>
    </svg>
  );
}

export default BackIcon;
